import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    primaryColor: string;
    secondaryColor: string;
    tertiaryColor: string;
    whiteColor: string = "#fff";
    primaryContrast: string;
    secondaryContrast: string;
    tertiaryContrast: string;
    theme: any = {};


    constructor() {
        this.getTheme();
    }

    getTheme() {
        
    }
}